module.exports = __webpack_public_path__ + "img/img-relay-step2.fd46422a.svg";